/*
*###############################################################################
*Module Name                   : BillOfMeterialMaster.js                       #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               : I Dinisuru Balasuriya                         #
*Date                          : Monday, August 15th 2022, 10:14:01 am         #
*Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/

import React, { useState, useEffect } from 'react'
import { MetaTags } from 'react-meta-tags'
import {
    Card,
    Col,
    Container,
    Row,
    CardBody,
} from 'reactstrap'

//**Importing required componant files   */
import Breadcrumb from 'components/Common/Breadcrumb'
import DPTopToolBar from 'framework/widgets/DPTopToolBar'
import BillOfMeterialContent from './BillOfMeterialContent'
import DPInfoBox from 'framework/layout/DPInfoBox'
import { Text, Numeric, DecimalValidation } from "../../../framework/validators/TextValidation"
import DPAlert from "../../../framework/widgets/DPAlert"
import DPLoadingAlert from 'framework/widgets/DPLoadingAlert'
import DPPermission from 'framework/widgets/DPPermission'
import * as XLSX from "xlsx";
import DPPrintOption from 'framework/widgets/DPPrintOptions'
//**End Importing required componant files */

import { Context } from '../../../app-contexts/CommonContexts';
import { useHistory } from 'react-router-dom';
import { useContext } from 'react'
import { getProductDetailsCode } from 'pages/Masters/Product-Master/ProductController'

const BillOfMeterialMaster = (props) => {


    const {
        isHeadOffice, getMenuDetails, masterAuditLog, getSelectedMasterPermissions, fetchAutoCode, addtoFavourite
    } = useContext(Context);

    let history = useHistory();
    //*** User input related states */
    const [strCode, SetCode] = useState("");// Set Code
    const [strDescription, SetDescription] = useState("")//Set Description
    const [IsActive, SetActive] = useState(true)//Set Active state
    const [dbCazeSize, SetSize] = useState(parseFloat(1))//Set Bom Size
    const [proCode, SetProCode] = useState("")//Set Product Code
    const [proDescription, SetProDescription] = useState("")//Set Product Description
    const [totalCost, SetTotalCost] = useState(parseFloat(0).toFixed(2))//Set Total Cost
    const [menuCode, SetMenuCode] = useState("")
    const [arRow, setarRow] = useState([{
        id: 1,
        Subcode: "",
        subDesc: "",
        subCost: 0,
        caseSize: 0,
        Unit: "",
        UnitName: "",
        qty: 1,
        amount: 0,
        baseProduct: false,
        isDecimal: 0,
        isDisabled: false
    }])
    //*** End User input related states */

    //*** User Activity related states*/
    const [show, setShow] = useState(false)
    const [AlertMsg, setAlertMsg] = useState('')
    const [AlertColor, setAlertColor] = useState('')
    const [modal_xlarge, setmodal_xlarge] = useState(false)
    const [modalXlargeProduct, setmodalXlargeProduct] = useState(false)
    const [disabled, setDisabled] = useState(false)
    const [disabledCode, setDisabledCode] = useState(false)
    const [proDisable, setProDisable] = useState(false)
    const [saveEnable, setSaveEnable] = useState(true)
    const [crEnable, setCrEnable] = useState(false)
    const [crBy, setCrBy] = useState("")
    const [mdBy, setMdBy] = useState("")
    const [crDate, setCrDate] = useState("")
    const [mdDate, setMdDate] = useState("")
    const [deleteEnable, SetDeleteEnable] = useState(false)
    const [Reason, setReason] = useState("Created")
    const [editEnable, SetEditEnable] = useState(false)
    const [finishProductCode, setFinishProductCode] = useState("")
    const [finishProductDesc, setFinishProductDesc] = useState("")
    const [model_xlarge_finishpro, setmodel_xlarge_finishpro] = useState(false)


    //Alert Parameters
    const [sweetAlertShow, setsweetAlertShow] = useState(false)
    const [AlertDescription, setAlertDescription] = useState(false)
    const [AlertConfirmOption, setAlertConfirmOption] = useState(0)
    const [ErrorMsg, setErrorMsg] = useState('')
    const [addNew, SetAddNew] = useState(true)
    //*** Get and Set values when user search code */

    //*****Menu Rights Start*/
    const [menuAccess, SetMenuAccess] = useState(false)
    const [menuCreate, SetMenuCreate] = useState(false)
    const [menuDelete, SetMenuDelete] = useState(false)
    const [menuModify, SetMenuModify] = useState(false)
    const [menuPrint, SetMenuPrint] = useState(false)
    const [menuProcess, SetMenuProcess] = useState(false)
    const [menuName, SetMenuName] = useState("")
    const [parentName, SetParentName] = useState("")
    const [LocationCode, setLocationCode] = useState("")
    const [LogUserType, setLogUserType] = useState("")
    const [LogCompanyCode, setLogCompanyCode] = useState("")
    //*****Menu Rights End */

    /**********Loading Alert */
    const [loadingAlert, SetLoadingAlert] = useState(false)
    const [loadingAlertTitle, SetLoadingAlerttitle] = useState("")
    /**********End Loading Alert */

    //autocode generation related newly added code
    const [codeButton, setCodeButton] = useState(true)
    const [searchdisabled, setSearchdisabled] = useState(false)
    const [nullCode, setNullCode] = useState(false)
    const [autoCode, setAutoCode] = useState(false)

    //User Permission related usestates
    const [permissionAlertShow, setPermissionAlertShow] = useState(false)
    const [permissionAlertTitle, setPermissionAlertTitle] = useState("")
    const [permissionReasonShow, setPermissionReasonShow] = useState(false)
    const [permissionName, setPermissionName] = useState("")
    const [permissionPassword, setPermissionPassword] = useState("")
    const [permissionNameDisable, setPermissionNameDisable] = useState(false)
    const [printoptionShow, setprintoptionShow] = useState(false)

    const [valueUpload, setvalueUpload] = useState("")
    const [items, setItems] = useState([]);
    const [Excelitems, setExcelItems] = useState([]);
    const [helpUrl, setHelpUrl] = useState("")
    const [currentPage, setCurrentPage] = useState(1)

    var time = process.env.REACT_APP_ALERTTIMEOUT

    const authToken = localStorage.getItem("authToken")
    const ApiURL = window.Links.ApiURL


    //**Get File Details */
    useEffect(async () => {
        var obj = JSON.parse(localStorage.getItem("authUser"))
        var LogUserType = obj[2]
        var menuDetail = await getMenuDetails(window.location.pathname + window.location.search)
        var menu = menuDetail && menuDetail.menuTag ? menuDetail.menuTag : history.push('/dashboard');
        var parentname = menuDetail?.parentName
        SetParentName(parentname)
        var LocationCode = obj[3]
        var CompanyCode = obj[5]
        setLocationCode(LocationCode)
        setLogUserType(LogUserType)
        setLogCompanyCode(CompanyCode)


        var requestOptions = {
            method: 'GET',
            headers: {
                "Authorization": `Bearer ${authToken}`
            },
            redirect: 'follow'
        };

        fetch(`${ApiURL}login/menu/${LogUserType}/${menu}`, requestOptions)
            .then(response => response.json())
            .then(result => {
                SetMenuAccess(result.data.strMenuAccessRight)
                SetMenuCreate(result.data.strMenuCreateRight)
                SetMenuDelete(result.data.strMenuDeleteRight)
                SetMenuModify(result.data.strMenuModifyRight)
                SetMenuPrint(result.data.strMenuPrintRight)
                SetMenuProcess(result.data.strMenuProcessRight)
                SetMenuName(result.data.strMenuName)
                SetMenuCode(result.data.strMenuTag)
                setPermissionReasonShow(result.data.strMenuReasonShow)
                setHelpUrl(result.data.strHelpUrl)
                fetch(`${ApiURL}common/autocode/${result.data.strMenuTag}`, {
                    method: "GET",
                    headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` },
                }).then(Response => Response.json())
                    .then(responseData => {

                        if (responseData.success == true) {
                            if (responseData.data.length == 0) {
                                setNullCode(true)
                            } else {
                                setAutoCode(responseData.data)
                            }
                        } else {
                            setNullCode(true)
                        }
                    })

            }).catch(error =>
                console.log('error', error)
            );

    }, [strCode])

    useEffect(async () => {
        var obj = JSON.parse(localStorage.getItem("authUser"))
        var LogUserType = obj[2]
        var LocationCode = obj[3]
        var LocationName = obj[4]
        var CompanyCode = obj[5]
        var menuDetail = await getMenuDetails(window.location.pathname + window.location.search)
        var menu = menuDetail && menuDetail.menuTag ? menuDetail.menuTag : history.push('/dashboard');
        var parentname = menuDetail?.parentName
        var menuTAG = ""
        const AuditLog = {
            "strMenuCode": menu,
            "strUserName": LogUserType,
            "strLocCode": LocationCode,
            "strComcode": CompanyCode,
            "strReason": ""
        }
        var requestOptions = {
            method: 'POST',
            headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` },
            body: JSON.stringify(AuditLog),
        };

        fetch(`${ApiURL}login/menu/audit`, requestOptions)
            .then(async (response) => await response.json())
            .then(result => {
                console.log(result)
            }).catch(error =>
                console.log('error', error)
            );

    }, [])


    const readExcel = (file) => {
        const promise = new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsArrayBuffer(file);

            fileReader.onload = (e) => {
                const bufferArray = e.target.result;

                const wb = XLSX.read(bufferArray, { type: "buffer" });

                const wsname = wb.SheetNames[0];

                const ws = wb.Sheets[wsname];

                const data = XLSX.utils.sheet_to_json(ws);

                setExcelItems(data);
                resolve(data);
            };

            fileReader.onerror = (error) => {
                reject(error);
            };
        });

        promise.then((d) => {
            setItems(d);
        });
    };



    function getData(searchData) {

        if (searchData != "") {

            SetLoadingAlert(true)
            SetLoadingAlerttitle("Fetching Data...")

            fetch(`${ApiURL}BOM/search/${searchData}/${LocationCode}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${authToken}`
                }
            }).then(Response => Response.json())
                .then(responseData => {
                    SetLoadingAlert(false)
                    if (responseData.success == true) {

                        let modifiedRows = []

                        const newArray = [...responseData.data]


                        SetDescription(newArray[0].strBOMName)
                        SetSize(newArray[0].dbCazeSize)
                        SetActive(newArray[0].status)
                        // SetTotalCost(parseFloat(newArray[0].dbCost).toFixed(3))
                        
                        setCrBy(newArray[0].createdBy)
                        setCrDate(newArray[0].createdDate)
                        setMdBy(newArray[0].modifiedBy)
                        setMdDate(newArray[0].modifiedDate)
                        SetProCode(newArray[0].baseProCode)
                        SetProDescription(newArray[0].baseProDesc)
                        setFinishProductCode(newArray[0].finishProCode)
                        setFinishProductDesc(newArray[0].finishProDesc)
                        debugger
                        //add sub products to array
                        newArray[0].productbomdetails.map((dr) => {
                            const lineToatal = parseFloat(parseFloat(dr.dboM_QTY) * (parseFloat(dr.boM_COST) / parseFloat(dr.boM_CASE))).toFixed(3)
                            modifiedRows.push({
                                id: modifiedRows.length + 1,
                                Subcode: dr.dboM_SPLU,
                                subDesc: dr.mplU_DESC,
                                Unit: dr.dboM_UNIT,
                                UnitName: dr.dboM_UNITNAME,
                                qty: dr.dboM_QTY,
                                subCost: dr.boM_COST,
                                caseSize: dr.boM_CASE,
                                amount: lineToatal,
                                baseProduct: dr.dboM_SPLU == newArray[0].baseProCode ? true : false,
                                isDecimal: dr.isDecimal,
                                isDisabled: true,
                                unitSize: dr.unitSize
                            })
                        })

                        

                        //find the base product and add to the first row
                        if (modifiedRows.length != 0) {
                            const basePro = modifiedRows.find((dr) => dr.Subcode == newArray[0].baseProCode)
                            const newProducts = modifiedRows.filter((dr) => dr.Subcode != newArray[0].baseProCode)
                            if (basePro != undefined) {
                                newProducts.unshift(basePro)
                            }

                            newProducts.map((dr, index) => {
                                dr.id = index + 1
                            })

                            CalculateTotalOnload(newProducts , newArray[0].dbCazeSize)

                            setarRow(newProducts == undefined || newProducts.length == 0 ? [{
                                id: 1,
                                Subcode: "",
                                subDesc: "",
                                subCost: 0,
                                caseSize: 0,
                                Unit: "",
                                UnitName: "",
                                qty: 1,
                                amount: 0,
                                baseProduct: false,
                                isDecimal: 0,
                                isDisabled: false,
                                unitSize: 0
                            }] : newProducts)
                        } else {
                            setarRow([{
                                id: 1,
                                Subcode: "",
                                subDesc: "",
                                subCost: 0,
                                caseSize: 0,
                                Unit: "",
                                UnitName: "",
                                qty: 1,
                                amount: 0,
                                baseProduct: false,
                                isDecimal: 0,
                                isDisabled: false,
                                unitSize: 0
                            }])
                        }

                        setCrEnable(true)
                        setDisabled(true)
                        setDisabledCode(true)
                        setSaveEnable(false)
                        SetAddNew(false)
                        SetDeleteEnable(true)
                        SetEditEnable(true)
                        setSearchdisabled(true)


                    } else {
                        displayAlertMessage('success', 'Record Not Found !')
                        if (nullCode == false) {
                            setDisabledCode(true)
                            SetCode("")
                        } else {
                            setDisabledCode(true)
                        }
                    }
                }).catch(error => {
                    SetLoadingAlert(false)
                    console.log(error.message)
                })


        } else {
            if (nullCode == false) {
                displayAlertMessage('success', "Record Not Found !")
                setDisabledCode(true)
                SetCode("")
            } else {
                displayAlertMessage('success', "Record Not Found !")
                setDisabledCode(true)
            }
        }
    }

    //*** End useEffect */


    // print Function
    async function handlePrint(option) {
        var option = option

        SetLoadingAlert(true)
        SetLoadingAlerttitle("Generating Report...")

        const ReportURL = window.Links.ReportURL
        await fetch(`${ReportURL}api/designation/report/${LogUserType}`, {
            method: "GET",
            headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` }
        }).then(Response => Response.json())
            .then(responseData => {


                if (responseData.success == true) {
                    if (option == "PDF") {
                        {
                            const msg = responseData.msg
                            window.open(`${ReportURL}temp_print/${msg.replace("\r\n", '')}.pdf`)
                        }
                    }
                    if (option == "XCEL") {
                        {
                            const msg = responseData.msg
                            window.open(`${ReportURL}temp_print/${msg.replace("\r\n", '')}.xls`)
                        }
                    }

                }
                SetLoadingAlert(false)
            }).catch(error => {
                console.log(error.message)
                SetLoadingAlert(false)
            })
    }

    function tog_xlarge() {
        setmodal_xlarge(!modal_xlarge)
        removeBodyCss()
    }

    function tog_xlargePro() {
        setmodalXlargeProduct(!modalXlargeProduct)
        removeBodyCss()
    }


    function tog_xlarge_finishpro() {
        setmodel_xlarge_finishpro(!model_xlarge_finishpro)
        removeBodyCss()
    }

    //removebodyCss function
    function removeBodyCss() {
        document.body.classList.add("no_padding")
    }

    //save button function
    const handlesave = async (e) => {


        var newCode = ""
        //set autogenerate code to as CODE just for display purpuse
        if (addNew == true && nullCode == false) {
            SetCode(autoCode)
            newCode = autoCode
        } else {
            newCode = strCode
        }

        if (strCode == "" && nullCode == true) {
            displayAlertMessage("danger", "Please Enter BOM Code !")
            return;
        }
        if (strDescription == "") {
            displayAlertMessage('danger', "Please Enter description")
            return;
        }

        var ProductBOM = [];

        if (arRow.length == 0) {
            displayAlertMessage('danger', "Please Enter Products for BOM")
            return;
        }

        // if (arRow.some((dr) => dr.baseProduct == true) == false) {
        //     displayAlertMessage('danger', "Please Select Base Product")
        //     return;
        // }
        if (finishProductCode == "") {
            displayAlertMessage('danger', "Please Select Finish Product")
            return;
        }

        // if (proCode == "") {
        //     displayAlertMessage('danger', "Please Select Base Product")
        //     return;
        // }

        arRow.forEach((dr) => {
            if (dr.Subcode != "") {
                ProductBOM.push(ProductBOMBuilder(newCode, proCode, dr.Subcode, dr.Unit, dr.qty))
            }
        })

        var ActiveStat = IsActive == "1" ? true : false; //checking active sate
        const BillOfMeterial = {
            "strBOMCode": newCode,
            "strBOMName": strDescription,
            "strBasePro": proCode,
            "strFinishPro": finishProductCode,
            "dbCazeSize": parseFloat(dbCazeSize),
            "strMenuCode": menuCode,
            "PRODUCTBOMDETAILS": ProductBOM,
            "dbCost": parseFloat(totalCost),
            "strStatus": ActiveStat,
            "strLoggedCompany": LogCompanyCode,
            "strLoggedLocation": LocationCode,
            "strReason": Reason,
            "strCreateBy": LogUserType,
            "blAddNew": addNew
        }

        SetLoadingAlert(true)
        if (addNew == true) {
            SetLoadingAlerttitle("Saving...")
        } else {
            SetLoadingAlerttitle("Updating...")
        }


        fetch(`${ApiURL}BOM`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${authToken}`
                },
                body: JSON.stringify(BillOfMeterial)
            }
        ).then(Response => {
            SetLoadingAlert(false)
            if (Response.status == "200") {
                Response.json()
                    .then(responseData => {
                        if (responseData.data == "Record Already Exsist!") {
                            displayAlertMessage('danger', responseData.data)
                        } else if (responseData.data == "Code Already Exsist!") {
                            displayAlertMessage('danger', responseData.data)
                        } else {
                            displayAlertMessage('success', responseData.data)
                            ClearItem()
                        }
                    }
                    )
            } else if (Response.status == "400") {
                Response.json()
                    .then(responseData => {
                        setErrorMsg(responseData.msg)
                    })
                setDisabled(false)
                setDisabledCode(false)
                displayAlertMessage('danger', "Error !")
            } else {
                ClearItem()
            }
        }).catch(error => {
            SetLoadingAlert(false)
            console.log(error.message)
        })

        //***save/update end */
    }

    const ProductBOMBuilder = (strBOMCode, code, subcode, unit, Qty) => {
        return {
            "DBOM_CODE": strBOMCode,
            "DBOM_MPLU": code,
            "DBOM_SPLU": subcode,
            "DBOM_UNIT": unit,
            "DBOM_QTY": parseFloat(Qty)
        }
    }

    //*** Get user selected row details */
    const GetSelectRow = (e, row, isSelect, rowIndex) => {
        SetCode(row.BOM_CODE);
        getData(row.BOM_CODE)
        setDisabled(true)
        setDisabledCode(true)
        setSaveEnable(false)
        setmodal_xlarge(!modal_xlarge);
        setCrEnable(true)
    }

    const GetSelectRowProduct = (e, row, isSelect, rowIndex) => {
        SetProCode(row.PLU_CODE);
        SetProDescription(row.PLU_DESC);
        setmodalXlargeProduct(!modalXlargeProduct);
        setProDisable(true)
    }

    const GetSelectRowFinishProduct = (e, row, isSelect, rowIndex) => {
        setFinishProductCode(row.PLU_CODE);
        setFinishProductDesc(row.PLU_DESC);
        setmodel_xlarge_finishpro(!model_xlarge_finishpro);
    }



    //edit button function    
    const handleEdit = e => {
        setDisabled(false)
        setDisabledCode(true)
        setSaveEnable(true)
        SetDeleteEnable(true)
        SetEditEnable(false)
    }

    //new button function
    const handleNew = e => {
        //e.preventDefault()
        ClearItem();
        setShow(false)
        setSaveEnable(true)
        setCrEnable(false)
    }

    //clear fields function    
    const ClearItem = () => {
        SetCode("")
        SetDescription("")
        SetActive(true)
        setDisabledCode(false)
        setDisabled(false)
        setCrEnable(false)
        setErrorMsg('')
        SetAddNew(true)
        SetDeleteEnable(false)
        SetDeleteEnable(false)
        setNullCode(false)
        setSearchdisabled(false)
        SetEditEnable(false)
        setSaveEnable(true)
        setReason("Created")
        setSaveEnable(true)
        setPermissionName("")
        setPermissionPassword("")
        setPermissionNameDisable(false)
        setCodeButton(true)
        setProDisable(false)
        setExcelItems([])
        setarRow([{
            id: 1,
            Subcode: "",
            subDesc: "",
            subCost: 0,
            caseSize: 0,
            Unit: "",
            UnitName: "",
            qty: 1,
            amount: 0,
            baseProduct: false,
            isDecimal: 0
        }])
        SetSize(parseFloat(1))
        SetTotalCost(parseFloat(0).toFixed(2))
        SetProCode("")
        SetProDescription("")
        setFinishProductCode("")
        setFinishProductDesc("")
        setTimeout(() => {
            setExcelItems([])
        }, 1)
        setCurrentPage(1)
    }

    //********Delete button function */
    const handleDelete = () => {

        const rowDelete = {
            "strMenuCode": menuCode,
            "strCode": strCode,
            "strLoggedCompany": LogCompanyCode,
            "strLoggedLocation": LocationCode,
            "strReason": Reason,
            "strCreateBy": LogUserType
        }

        //loading alert show
        SetLoadingAlert(true)
        SetLoadingAlerttitle("Deleting...")

        fetch(`${ApiURL}Common/Delete`,
            {
                method: "POST",
                headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` },
                body: JSON.stringify(rowDelete)
            }
        ).then(Response => {
            if (Response.status == "200") {
                SetLoadingAlert(false)
                Response.json()
                    .then(responseData => {

                        if (responseData.data == "Cannot Delete, Record Already Used!") {
                            displayAlertMessage('warning', responseData.data)
                        } else {
                            ClearItem()
                            displayAlertMessage('success', responseData.data)
                        }
                    }
                    )
            } else if (Response.status == "400") {
                SetLoadingAlert(false)
                Response.json()
                    .then(responseData => {
                        setErrorMsg(responseData.msg)
                    })
                setDisabled(false)
                setDisabledCode(false)
                displayAlertMessage('danger', "Error !")
            } else {
                SetLoadingAlert(false)
                ClearItem()
            }
        }).catch(error => {
            console.log(error.message)
        })
    }
    //*********Delete button function end */

    //CODE AUTO GEN
    const AutoGenerateCode = async () => {
        await fetch(`${ApiURL}common/autocode/${menuCode}`, {
            method: "GET",
            headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` },
        }).then(Response => Response.json())
            .then(responseData => {
                if (responseData.success == true) {
                    if (responseData.data.length > 0) {
                        SetCode(responseData.data)
                        setAutoCode(responseData.data)
                    } else {
                        setDisabledCode(false)
                    }
                }
            })
    }


    //**Permission Check */
    const permission = (operation) => {
        const permissiondata = {
            strUsername: permissionName,
            strPassword: permissionPassword,
            strLocation: LocationCode,
            strMenuCode: menuCode
        }

        clearPermissionInputs()

        fetch(`${ApiURL}login/userpermission`,
            {
                method: "POST",
                headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` },
                body: JSON.stringify(permissiondata)
            }
        ).then(Response => {
            if (Response.status == "200") {
                Response.json()
                    .then(responseData => {

                        let Access = (responseData.data.strMenuAccessRight)
                        let Create = (responseData.data.strMenuCreateRight)
                        let Delete = (responseData.data.strMenuDeleteRight)
                        let Modify = (responseData.data.strMenuModifyRight)
                        let Print = (responseData.data.strMenuPrintRight)
                        let Process = (responseData.data.strMenuProcessRight)

                        if (operation == "Save") {
                            if (Create == true) {
                                handlesave()
                            } else if (Modify == true) {
                                handlesave()
                            } else {
                                if (operation == "Save" && addNew == true) {
                                    displayAlertMessage('danger', "This user dosen't have permission to save")
                                } else {
                                    displayAlertMessage('danger', "This user dosen't have permission to edit")
                                }
                            }
                        } else if (operation == "Delete") {
                            if (Delete == true) {
                                handleDelete()
                            } else {
                                displayAlertMessage('danger', "This user don't have permission to delete !")
                            }
                        } else if (operation == "Print") {
                            if (Print == true) {
                                setprintoptionShow(true)
                            } else {
                                displayAlertMessage('danger', "This user don't have permission to print !")
                            }
                        }
                    }
                    )

            } else if (Response.status == "400") {
                setDisabled(false)
                setDisabledCode(false)
                displayAlertMessage('danger', "Oops something went wrong !")
                clearPermissionInputs()

            } else if (Response.status == "403") {
                setDisabled(false)
                setDisabledCode(false)
                displayAlertMessage('danger', "You have not Permission to make changes !")
                clearPermissionInputs()

            } else if (Response.status == "404") {
                setDisabled(false)
                setDisabledCode(false)
                displayAlertMessage('danger', "Password or User Name is Invalid !")
                clearPermissionInputs()

            } else {
                ClearItem()
            }
        }).catch(error => {
            console.log(error.message)
        })
    }

    const CalculateTotal = (size) => {
        var total = 0;
        arRow.forEach((row) => {
            if (row.Subcode != "") {
                total = parseFloat(parseFloat(total) + ((parseFloat(row.subCost) / parseFloat(row.caseSize)) * parseFloat(row.qty))).toFixed(3)
            }
        })
        SetTotalCost(parseFloat(parseFloat(total) / parseFloat(size)).toFixed(3))
    }

    const CalculateTotalOnload = (bomList, size) => {
        var total = 0;
        bomList.forEach((row) => {
            if (row.Subcode != "") {
                total = parseFloat(parseFloat(total) + ((parseFloat(row.subCost) / parseFloat(row.caseSize)) * parseFloat(row.qty))).toFixed(3)
            }
        })
        SetTotalCost(parseFloat(parseFloat(total) / parseFloat(size)).toFixed(3))
    }


    async function getProductData(searchData) {

        if (searchData == "") return

        var productData = await getProductDetailsCode(searchData, LocationCode)

        if (productData.length == 0) {
            setFinishProductCode("")
            setFinishProductDesc("")
            displayAlertMessage('danger', "Invalid Product Code !")
        } else {
            setFinishProductCode(productData[0].strProductCode)
            setFinishProductDesc(productData[0].strProductDesc)
        }



    }


    // Function for displaying Alert Messages.
    function displayAlertMessage(color, message) {
        setAlertColor(color)
        setAlertMsg(message)
        setShow(true)

        setTimeout(() => {
            setShow(false)
        }, time)
    }


    //handle permission alert
    function handlePermissionAlert(LogUserType, reason, disable, alertShow) {
        setPermissionName(LogUserType)
        setReason(reason)
        setPermissionNameDisable(disable)
        setPermissionAlertShow(alertShow)
    }


    //Clear permission name & password
    function clearPermissionInputs() {
        setPermissionName("");
        setPermissionPassword("");
        setReason("");
    }

    //Handle Favourite Button
    const handleFavourite = async () => {
        var response = await addtoFavourite(menuCode, LogUserType);
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>{menuName}</title>
                </MetaTags>
                <Container fluid={true}>
                    <Breadcrumb title={parentName} breadcrumbItem={menuName}></Breadcrumb>
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardBody>
                                    <DPAlert
                                        confirm_both={sweetAlertShow}
                                        title={menuName}
                                        description={AlertDescription}
                                        showCancel={true}
                                        btnColor={"success"}
                                        cancelColor={"danger"}
                                        onConfirm={() => {
                                            setsweetAlertShow(false)
                                            if (AlertConfirmOption == 1) {

                                                if (addNew == true && menuCreate == true && permissionReasonShow == false) {
                                                    handlesave()
                                                } else if (addNew == true && menuCreate == true && permissionReasonShow == true) {
                                                    handlePermissionAlert(LogUserType, "Created", true, true)
                                                } else if (addNew == false && menuModify == true && permissionReasonShow == false) {
                                                    handlesave()
                                                } else if (addNew == false && menuModify == true && permissionReasonShow == true) {
                                                    handlePermissionAlert(LogUserType, "Updated", true, true)
                                                } else {
                                                    setPermissionReasonShow(true)
                                                    setPermissionAlertShow(true)
                                                }

                                            } else if (AlertConfirmOption == 2) {
                                                handleEdit()
                                            } else if (AlertConfirmOption == 3) {
                                                window.location.href = "/";
                                            } else if (AlertConfirmOption == 4) {
                                                handleNew()
                                            } else if (AlertConfirmOption == 6) {
                                                if (menuPrint == true && permissionReasonShow == false) {
                                                    setprintoptionShow(true)
                                                } else if (menuPrint == true && permissionReasonShow == true) {
                                                    handlePermissionAlert(LogUserType, "Printed", true, true)
                                                } else {
                                                    setPermissionReasonShow(true)
                                                    setPermissionAlertShow(true)
                                                }
                                            } else if (AlertConfirmOption == 5) {

                                                if (addNew == false && menuDelete == true && permissionReasonShow == false) {
                                                    handleDelete()
                                                } else if (addNew == false && menuDelete == true && permissionReasonShow == true) {
                                                    handlePermissionAlert(LogUserType, "Deleted", true, true)
                                                } else {
                                                    setPermissionReasonShow(true)
                                                    setPermissionAlertShow(true)
                                                }
                                            }
                                        }}
                                        onCancel={() => {
                                            setsweetAlertShow(false)
                                        }}
                                    />
                                    <DPPrintOption
                                        confirm_both={printoptionShow}
                                        title={menuName}
                                        description={permissionAlertTitle}
                                        showReason={permissionReasonShow}
                                        nameDisable={permissionNameDisable}
                                        showCancel={true}
                                        cancelColor={"danger"}
                                        onConfirmpdf={() => {
                                            handlePrint("PDF")
                                            setprintoptionShow(false)
                                        }}
                                        onConfirmxcel={() => {
                                            handlePrint("XCEL")
                                            setprintoptionShow(false)
                                        }}
                                        onCancel={() => {
                                            setprintoptionShow(false)
                                        }}
                                    />
                                    <DPPermission
                                        confirm_both={permissionAlertShow}
                                        title={menuName}
                                        description={permissionAlertTitle}
                                        showReason={permissionReasonShow}
                                        nameDisable={permissionNameDisable}
                                        showCancel={true}
                                        btnColor={"success"}
                                        cancelColor={"danger"}
                                        AlName={permissionName}
                                        AlNameOnchange={e => {
                                            let val2 = Text(e.target, 50, true, false, "any", true)
                                            setPermissionName(val2)
                                        }}
                                        AlPassward={permissionPassword}
                                        AlPasswardOnchange={e => {
                                            let val2 = Text(e.target, 50, true, true, "any", true)
                                            setPermissionPassword(val2)
                                        }}
                                        AlReason={Reason}
                                        AlReasonOnchange={e => {
                                            let val2 = Text(e.target, 50, true, false, "any", true)
                                            setReason(val2)
                                        }}
                                        onConfirm={() => {
                                            setPermissionAlertShow(false)
                                            if (AlertConfirmOption == 1) {
                                                permission("Save")
                                            } else if (AlertConfirmOption == 5) {
                                                permission("Delete")
                                            } else if (AlertConfirmOption == 6) {
                                                permission("Print")
                                            }
                                        }}
                                        onCancel={() => {
                                            setPermissionAlertShow(false)
                                            clearPermissionInputs()
                                        }}
                                    />
                                    <DPLoadingAlert
                                        confirm_both={loadingAlert}
                                        title={loadingAlertTitle}
                                    />
                                    <DPTopToolBar
                                        //Help Button
                                        helpEnable={helpUrl != "" ? true : false}
                                        helpClick={() => {
                                            window.open(helpUrl)
                                        }}
                                        //Favorite Button
                                        favoriteEnable={true}
                                        favoriteClick={handleFavourite}
                                        //New Button
                                        newEnable={true}
                                        newClick={() => {
                                            setAlertDescription("Do you wish to refresh the screen ?");
                                            setAlertConfirmOption(4)
                                            setsweetAlertShow(true)
                                        }}
                                        //Save Button
                                        saveEnable={saveEnable && isHeadOffice}
                                        saveClick={() => {
                                            setAlertDescription("Do you wish to save ?");
                                            setAlertConfirmOption(1)
                                            setsweetAlertShow(true)
                                        }}
                                        //ProcessButton
                                        processEnable={false}
                                        processClick={() => {
                                            alert("Process")
                                        }}
                                        //Edit Button
                                        editEnable={editEnable && isHeadOffice}
                                        editClick={() => {
                                            setAlertDescription("Do you wish to edit ?");
                                            setAlertConfirmOption(2)
                                            setsweetAlertShow(true)
                                        }}
                                        //Print Button
                                        printEnable={true}
                                        printClick={() => {
                                            setReason("Printed")
                                            setAlertDescription("Do you wish to print ?");
                                            setAlertConfirmOption(6)
                                            setsweetAlertShow(true)
                                        }}
                                        //Delete Button
                                        deleteEnable={deleteEnable}
                                        deleteClick={() => {
                                            setReason("Deleted")
                                            setAlertDescription("Do you wish to delete ?");
                                            setAlertConfirmOption(5)
                                            setsweetAlertShow(true)
                                        }}
                                        //Exit Button
                                        exitEnable={true}
                                        exitClick={() => {
                                            setAlertDescription("Do you wish to exit ?");
                                            setAlertConfirmOption(3)
                                            setsweetAlertShow(true)
                                        }}
                                    />
                                    <Row>
                                        <BillOfMeterialContent
                                            GetSelectRow={GetSelectRow}
                                            CodeValue={strCode}
                                            CodeonChange={e => {
                                                let val1 = Text(
                                                    e.target,
                                                    5,
                                                    true,
                                                    false,
                                                    "upper",
                                                    false
                                                )
                                                SetCode(val1)
                                            }}
                                            DescValue={strDescription}
                                            DescOnChange={e => {
                                                let val2 = Text(
                                                    e.target,
                                                    100,
                                                    true,
                                                    true,
                                                    "any",
                                                    true
                                                )
                                                SetDescription(val2)
                                            }}
                                            ActiveSw={IsActive}
                                            SwonChange={() => {
                                                SetActive(!IsActive)
                                            }}
                                            modelTrigger={tog_xlarge}
                                            modelOpen={modal_xlarge}
                                            show={show}
                                            disabled={disabled}
                                            disabledCode={disabledCode}
                                            AlertColor={AlertColor}
                                            AlertMsg={AlertMsg}
                                            CodeOnBlur={e => {
                                                getData(e.target.value)
                                            }}
                                            ErrorMsg={ErrorMsg}
                                            menuName={menuName}
                                            onButtonClick={e => {
                                                AutoGenerateCode()
                                                setCodeButton(true)
                                            }}
                                            btnDisable={codeButton}
                                            SearchDisable={searchdisabled}
                                            showFileUpload={(e) => {
                                                const file = e.target.files[0];
                                                readExcel(file);
                                                setvalueUpload(e.target.value)
                                            }}
                                            valueUpload={valueUpload}
                                            menuCode={menuCode}
                                            tog_xlargePro={tog_xlargePro}
                                            modalXlargeProduct={modalXlargeProduct}
                                            DataRow={arRow}
                                            setarRow={setarRow}
                                            SetTotalCost={SetTotalCost}
                                            SetSize={e => {
                                                let val101 = Numeric(e.target, 10, 3, false)
                                                SetSize(val101)
                                            }}
                                            dbCazeSizeonBlur={e => {
                                                let dbCazeSize = DecimalValidation(e.target.value, 1)
                                                SetSize(dbCazeSize)
                                                CalculateTotal(dbCazeSize)

                                            }}
                                            totalCost={totalCost}
                                            proCode={proCode}
                                            dbCazeSize={dbCazeSize}
                                            GetSelectRowProduct={GetSelectRowProduct}
                                            autoCode={autoCode}
                                            proDescription={proDescription}
                                            proDisable={proDisable}
                                            SetProDescription={SetProDescription}
                                            SetProCode={SetProCode}
                                            finishProductCode={finishProductCode}
                                            finishProductDesc={finishProductDesc}
                                            tog_xlarge_finishpro={tog_xlarge_finishpro}
                                            model_xlarge_finishpro={model_xlarge_finishpro}
                                            GetSelectRowFinishProduct={GetSelectRowFinishProduct}
                                            addNew={addNew}
                                            finishProductCodeOnChange={e => {
                                                let val2 = Text(
                                                    e.target,
                                                    25,
                                                    true,
                                                    false,
                                                    "any",
                                                    true
                                                )
                                                    setFinishProductCode(val2)
                                            }}
                                            finishProductCodeOnBlur={e => {
                                                getProductData(e.target.value)
                                            }}
                                            LocationCode={LocationCode}
                                            currentPage={currentPage}
                                            setCurrentPage={setCurrentPage}
                                        />
                                    </Row>
                                    <Row>
                                        {crEnable ? (
                                            <DPInfoBox
                                                createdBy={crBy}
                                                createdOn={crDate != '1900-01-01 00:00:00' ? (crDate) ? crDate.replace('T', ' ') : "" : ''}
                                                modifiedBy={mdBy}
                                                modifiedOn={mdDate != '1900-01-01 00:00:00' ? (mdDate) ? mdDate.replace('T', ' ') : "" : ''}
                                            />
                                        ) : null}
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>

        </React.Fragment>
    )

}

export default BillOfMeterialMaster